import React from "react";

const DownloadLocalApk = () => {
  const apkPath = "/downloads/datt_1.1.2.apk";

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <a
        href={apkPath}
        download
        style={{
          padding: "10px 20px",
          backgroundColor: "#4CAF50",
          color: "#fff",
          textDecoration: "none",
          borderRadius: "5px",
          fontSize: "16px",
        }}
      >
        Download Android
      </a>
    </div>
  );
};

export default DownloadLocalApk;
